module.exports = __webpack_public_path__ + "media/28.285e198d.wav";